import * as types from './constants';

// Create Smart Group
export const createSmartGroupRequest = data => (
  { type: types.CREATE_SMART_GROUP_REQUEST, payload: data }
);

export const createSmartGroupDone = data => (
  { type: types.CREATE_SMART_GROUP_DONE, payload: data }
);

export const createSmartGroupFailed = errors => (
  { type: types.CREATE_SMART_GROUP_FAILED, payload: errors }
);

export const createSmartGroupReset = () => (
  { type: types.CREATE_SMART_GROUP_RESET }
);